import React from 'react';
import { useIntl } from 'react-intl';

import * as S from './TaxpayerDropdown.styles';
import Dropdown, { DropdownItem } from '@src/components/ui/Dropdown';
import { Plus } from '@src/components/ui/Icon/outline';
import IconButton from '../../../ui/IconButton';
import TaxpayerItem from './TaxpayerItem';
import useModal from '@src/hooks/useModal';
import CreateBusinessForm from '@src/components/shared/form/CreateBusinessForm';

import { useHistory } from 'react-router';
import useSettings from '@src/hooks/useSettings';

function TaxpayerDropdown() {
  const { business, currentUser, setCurrentBusinessId } = useSettings();
  const intl = useIntl();
  const history = useHistory();
  const { open: openModal } = useModal(CreateBusinessForm);

  const handleOnClick = ({ businessId }: { businessId: string }) => {
    setCurrentBusinessId(businessId);
    history.push('/');
  };

  const handleNewTaxpayerClick = () => {
    openModal({});
  };

  return (
    <S.TaxPayerDropdownContainer>
      <Dropdown
        rows={5}
        fullWidth
        selectedNode={
          <TaxpayerItem
            imageUrl={business?.imageUrl}
            name={business?.name}
            strong
          />
        }
      >
        {currentUser?.businesses?.map((option, index) => {
          return (
            <DropdownItem
              key={index}
              onClick={() => handleOnClick({ businessId: option.id })}
            >
              <TaxpayerItem
                imageUrl={option.imageUrl}
                name={option.name}
                selected={option.name === business?.name}
              />
            </DropdownItem>
          );
        })}
        <DropdownItem onClick={handleNewTaxpayerClick}>
          <S.TaxPayerOption>
            <IconButton variant="ghosted" compact>
              <Plus />
            </IconButton>
            <p>
              {intl.formatMessage({
                defaultMessage: 'Agregar razón social',
                id: 'jtpj5M',
              })}
            </p>
          </S.TaxPayerOption>
        </DropdownItem>
      </Dropdown>
    </S.TaxPayerDropdownContainer>
  );
}

export default TaxpayerDropdown;
